import React from 'react';
import styles from './Group.scss';
import classNames from 'classnames';
import { ResponsiveSize } from '../Types';
import { GroupContext } from './GroupContext';

export interface GroupItem {
  element: React.ReactNode;
  flex?: number;
  separator?: boolean;
}

export interface GroupProps {
  /**
   * Items
   */
  items: GroupItem[];
  /**
   * Element size, e.g. xs, sm, etc.
   */
  size?: ResponsiveSize;
  /**
   * Additional class names
   */
  className?: string;
}

/**
 * Primary UI component for user interaction
 */
export const Group: React.FC<GroupProps> = ({ size = 'block', ...props }) => {
  return (
    <div
      className={classNames(
        styles['au-group'],
        {
          [styles[`au-group--width-${size}`]]: size && size != 'block',
          [styles[`au-group--block`]]: size == 'block',
        },
        props.className,
      )}>
      {props.items.map((r, i) => (
        <GroupContext.Provider value={{ className: r.flex ? styles['au-group-item--block'] : styles['au-group-item--fixed'] }} key={i}>
          <div style={{ flex: r.flex }}>{r.element}</div>
          {r.separator ? <div className={styles['au-group-separator']}></div> : <></>}
        </GroupContext.Provider>
      ))}
    </div>
  );
};
